import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import { AddressModalContainer, CustomCheckbox, ModalContainer } from "../styled";
import { AddrSearchModal } from "../../../../mypage/scheduler/component/styled/calendarEntry";

import { AiOutlineClose } from "react-icons/ai";

import DaumPostcode from "react-daum-postcode";

import SectionHeader from "../../common/sectionTitle";
import AddressInput from "./addressInput";

import useGlobalScroll from "../../../../../hooks/useGlobalScroll";

const AddressModal = ({ openModal, closeModal, target, toggleModal, getAddresses, addresses }) => {
  const user = useSelector((state) => state?.user?.data[0]);

  const [showPostCode, setShowPostCode] = useState(false);
  const [formData, setFormData] = useState({
    nickname: "",
    recipientName: "",
    phone: {
      areaCode: "010",
      firstPart: "",
      secondPart: "",
    },
    postcode: "",
    address: "",
    detailAddress: "",
    memo: "",
    isDefault: false,
  });

  useGlobalScroll();

  useEffect(() => {
    if (target) {
      setFormData({ ...target, phone: splitTel(target.phone) });
    }
    if (addresses.length === 0) {
      setFormData((prev) => ({ ...prev, isDefault: true }));
    }
  }, [target]);

  const changeTel = (key, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: onlyNumber(value),
      },
    }));
  };

  const changeInput = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // 전화번호 양식 수정
  const joinTel = ({ firstPart, secondPart }) => {
    if (!firstPart || !secondPart) return "";
    return `010${firstPart}${secondPart}`;
  };

  const splitTel = (tel) => {
    if (!tel) return {};

    const cleanTel = tel.replace(/-/g, "");

    if (!cleanTel.startsWith("010") || cleanTel.length !== 11) {
      return {};
    }

    return {
      areaCode: "010",
      firstPart: cleanTel.slice(3, 7),
      secondPart: cleanTel.slice(7, 11),
    };
  };

  // 카카오 주소
  const searchAddress = (data) => {
    const extraAddress = [data.bname, data.buildingName].filter(Boolean).join(", ");
    const fullAddress = data.address + (extraAddress ? ` (${extraAddress})` : "");

    console.log(data);
    setFormData((form) => ({ ...form, postcode: data.zonecode, address: fullAddress }));

    closePostCode();
  };

  const openPostCode = () => setShowPostCode(true);
  const closePostCode = () => setShowPostCode(false);

  const checkValidation = () => {
    const { nickname, recipientName, phone, postcode, address, detailAddress } = formData;

    if (!target && addresses.length >= 10) {
      toast.error("배송지는 최대 10개까지 등록할 수 있습니다.");
      return false;
    }

    if (!nickname.trim()) {
      toast.error("배송지명을 입력해주세요.");
      return false;
    }

    if (!recipientName.trim()) {
      toast.error("받는 분 이름을 입력해주세요.");
      return false;
    }

    if (!phone.areaCode || !phone.firstPart || !phone.secondPart) {
      toast.error("휴대전화를 정확히 입력해주세요.");
      return false;
    }

    if (!postcode.trim()) {
      toast.error("우편번호를 입력해주세요.");
      return false;
    }

    if (!address.trim()) {
      toast.error("주소를 입력해주세요.");
      return false;
    }

    if (!detailAddress.trim()) {
      toast.error("상세주소를 입력해주세요.");
      return false;
    }

    return true;
  };

  const updateAddress = async () => {
    const url = "/erp/address/upsert";
    const body = {
      input: {
        recipientName: formData.recipientName,
        nickname: formData.nickname,
        isDefault: formData.isDefault,
        memo: formData.memo,
        detailAddress: formData.detailAddress,
        address: formData.address,
        postcode: formData.postcode,
        phone: joinTel(formData.phone),
        mberNo: user.mberNo,
      },
    };

    if (target) {
      body.input.id = target.id;
    }

    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        await getAddresses();
        toggleModal();
      }
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };

  return (
    <ModalContainer onClick={(e) => e.target === e.currentTarget && toggleModal()}>
      <AddressModalContainer>
        {showPostCode && (
          <AddrSearchModal
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                closePostCode();
              }
            }}>
            <div className="modalContent">
              <DaumPostcode onComplete={searchAddress} />
              <button onClick={closePostCode}>닫기</button>
            </div>
          </AddrSearchModal>
        )}
        <div className="modal">
          <div className="form">
            <SectionHeader
              title={`배송지 ${target ? "수정" : "추가"}`}
              action={{
                icon: AiOutlineClose,
                className: "close",
                clickEvent: () => toggleModal(),
              }}
            />
            <div className="checkInfo">
              <CustomCheckbox>
                <input
                  type="checkbox"
                  checked={formData.isDefault}
                  disabled={
                    (!target && addresses.length === 0) || (target && addresses.length === 1)
                  }
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, isDefault: e.target.checked }))
                  }
                />
                <span></span>
              </CustomCheckbox>
              <p>기본 배송지로 설정</p>
            </div>
            <AddressInput
              formData={formData}
              changeInput={changeInput}
              changeTel={changeTel}
              openPostCode={openPostCode}
            />
          </div>
          <button
            className="submit"
            onClick={() => {
              if (!checkValidation()) {
                return;
              }

              openModal({
                isOpen: true,
                type: "confirmation",
                title: `배송지 ${target ? "수정" : "추가"}`,
                message: [`배송지를 ${target ? "수정" : "추가"}하시겠습니까?`],
                handleConfirm: () => updateAddress(),
                handleCancel: () => closeModal(),
              });
            }}>
            확인
          </button>
        </div>
      </AddressModalContainer>
    </ModalContainer>
  );
};

export default AddressModal;
